import * as THREE from 'three';
import { CameraMatrix } from './CameraMatrix';

export type CameraData = {position: number[], imagePath: string};
export type PinType = {
    height: number | undefined // flからの高さ
    matrix: THREE.Matrix4,
    cameraMatrix: CameraMatrix,
    position: THREE.Vector3,
    dir: THREE.Vector3
    imagePath: string};

export class PinInfo {

    constructor(private cameraDatas: CameraData[][], private floorHeight) {
        ;
    }

    public execute(): PinType[][] {

        const pinInfo: PinType[][] = [null, null, null];

        if (this.cameraDatas == null) return pinInfo;

        for (let i = 0; i < this.cameraDatas.length; i++) {
            if (this.cameraDatas[i] == null) {
                continue;
            }
            for (let j = 0; j < this.cameraDatas[i].length; j++) {  
                const data = this.cameraDatas[i][j];
                const matrix = new THREE.Matrix4();
                
                matrix.elements = data.position.map(val => val);   
                const cameraMatrix = new CameraMatrix(matrix.clone()); // 元の行列を保持         
                matrix.transpose(); // 転置

                const position = new THREE.Vector3();
                position.applyMatrix4(matrix);

                const dir = new THREE.Vector3(matrix.elements[8],matrix.elements[9], matrix.elements[10]);

                if (pinInfo[i] == null) pinInfo[i] = [];
                pinInfo[i].push({
                    height: this.floorHeight[i] ? Math.abs(position.y - this.floorHeight[i]) * 1000 : 0,
                    matrix: matrix,
                    cameraMatrix: cameraMatrix,
                    position: position,
                    dir: dir,
                    imagePath: data.imagePath
                });
            }
        }

        return pinInfo;

    }

}